interface LoadingStateProps {
  label?: string;
}

export default function LoadingState({ label = "内容加载中…" }: LoadingStateProps) {
  return (
    <div className="w-full flex flex-col items-center justify-center py-16 px-4">
      <span className="w-12 h-12 rounded-full border-4 border-primary-200 border-t-primary-500 animate-spin"></span>
      <p className="mt-4 text-sm text-foreground-600">{label}</p>
    </div>
  );
}